<template>
  <BreadCrumb PageTitle="Auto System Classification Results" />
  <div class="row">
    <div class="col-xxl-12">
      <div class="row">
        <div class="col-lg-12 d-flex">
          <div class="card mb-25 border-0 rounded-0 bg-white flex-grow-1">
            <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
              <template v-if="tableName">
                <AutoSystemClassificationResultsTable :tableName="tableName" />
              </template>
              <div v-else class="alert alert-warning mb-0" role="alert">
                A results table name was not provided in the route.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import BreadCrumb from '@/components/Common/DynamicBreadCrumb.vue';
import AutoSystemClassificationResultsTable from '@/components/ELSA/AutoSystemClassification/AutoSystemClassificationResultsTable.vue';

const parseRouteParam = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value) && value.length > 0) {
    return String(value[0]);
  }
  return '';
};

const parseNumericParam = (value: unknown): number | null => {
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (Array.isArray(value) && value.length > 0) {
    const parsed = parseInt(value[0] as string, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
};

export default defineComponent({
  name: 'AutoSystemClassificationResultsPage',
  components: {
    BreadCrumb,
    AutoSystemClassificationResultsTable
  },
  setup() {
    const route = useRoute();
    const leadID = ref<number | null>(null);
    const dataStreamID = ref<number | null>(null);
    const tableName = ref('');

    const syncFromRoute = () => {
      leadID.value = parseNumericParam(route.params.leadID);
      dataStreamID.value = parseNumericParam(route.params.dataStreamID);
      tableName.value = parseRouteParam(route.params.tableName);
    };

    onMounted(syncFromRoute);

    watch(
      () => route.params,
      () => {
        syncFromRoute();
      }
    );

    return {
      leadID,
      dataStreamID,
      tableName
    };
  }
});
</script>

<style scoped>
.card {
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
}

.letter-spacing {
  letter-spacing: 0.5px;
}
</style>
